import { Margin } from "@mui/icons-material";
import colorConfigs from "../../configs/colorConfigs";

const loginPageStyles = {
  container: {
    display: 'flex',
    flexDirection:'column',
    justifyContent: 'center',
    background:colorConfigs.secondary,
    minHeight: '70vh',
    
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius: '10px',
    padding: '24px',
    background:colorConfigs.backgrounds.white,
    boxShadow: colorConfigs.backgrounds.boxshadow,
    width:'90%',

},

  headerText: {
    color: 'var(--color-success-text)',
    fontWeight: 500,
  },
  subHeaderText: {
    color: 'var(--color-success-light)',
    fontWeight: 500,
  },
  descriptionText: {
    marginTop: '8px',
  },
  phoneInputContainer: {
    mt: 2,
    width: '100%',
    borderColor:colorConfigs.primary,
  },
  textField: {
    marginTop: '16px',
    width: '100%',
  },
  formActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mt: 2,
  },
  rememberMe: {
    color: 'text.secondary',
  },
  forgotPasswordLink: {
    textDecoration: 'none',
    color: colorConfigs.primary,
  },
  loginButton: {
    mt: 3,
    mb: 2,
    color: colorConfigs.secondary,
    backgroundColor: colorConfigs.primary,
    '&:hover': {
      backgroundColor: colorConfigs.primary,
    },
    borderRadius: '30px',
  },
  signupLink: {
    textDecoration: 'none',
    color: colorConfigs.primary,
  },
  submitButton: {
    mt: 3,
    mb: 2,
    color: colorConfigs.secondary,
    backgroundColor: colorConfigs.primary,
    '&:hover': {
      backgroundColor: colorConfigs.primary,
    },
    borderRadius: '30px',
    width: '20%',
  },
};

export default loginPageStyles;